import { CSSProperties } from "react";

import { useTheme } from "@hooks";

export const useEditGoalStyles = () => {
  const { theme } = useTheme();

  const harvestFloorCard: CSSProperties = {
    backgroundColor: theme.form.background,
    borderColor: theme.border,
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 1,
    padding: 16,
  };

  const harvestFloorValue: CSSProperties = {
    color: theme.text.default,
    fontSize: 18,
    fontWeight: 600,
  };

  const harvestFloorHint: CSSProperties = {
    color: theme.text.secondary,
    lineHeight: "12px",
  };

  return {
    input: {
      userSelect: "none",
      cursor: "pointer",
    } as CSSProperties,
    harvestFloorCard,
    harvestFloorValue,
    harvestFloorHint,
  };
};
